import React, { Component, Fragment } from 'react';

import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { Mutation } from 'react-apollo';
import fileDownload from "js-file-download";

import Table from './Table';
import { uri } from '../../../apollo';
import CardFooter from './CardFooter';
import { PORTAL_REFRESH_TOKEN } from './graphql'
import { buildQueryString } from '../../../helpers';
import Loading from '../../../assets/images/loading.gif';


function CardBody({ loading, error, data, onPageClick, initialPage }) {
    if (loading) return 'Loading...';
    if (error) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Não foi possível carregar a lista de vendas.
            </div>
        );
    }

    const { orders } = data || [];
    const { count } = data || 0;
    const pages =  Math.ceil(count/20);

    return (
        <Fragment>
            <Table orders={orders} />
            <CardFooter pages={pages} initialPage={initialPage} onPageClick={onPageClick} />
        </Fragment>
    );
}

export default class Card extends Component {
    constructor(props) {
        super(props);
        this.handleFileDownload = this.handleFileDownload.bind(this);
        this.zipReceipts = this.zipReceipts.bind(this);
        this.zipOrders = this.zipOrders.bind(this);

        this.sweetLoading = this.sweetLoading.bind(this);
        this.sweetError = this.sweetError.bind(this);
    }

    sweetLoading() {
      SweetAlert.fire({
        title: "Baixando...",
        imageUrl: Loading,
        imageWidth: 60,
        imageHeight: 60,
        text: "Seu download estará pronto em alguns instantes!",
        showConfirmButton: false,
        allowOutsideClick: false
      });
    }

    sweetError() {
      SweetAlert.fire({
        target: document.getElementById('swal-error'),
        type: 'error',
        title: 'Erro',
        text: 'Favor tentar novamente em alguns minutos e/ou diminua o filtro de pesquisa.'
      });
    }

    async zipReceipts(refresh_token) {
      this.sweetLoading();

      try {
        const token = await refresh_token()

        const URL = uri + '/portal/reports/zip-receipts/' + buildQueryString({
          partner: this.props.operatorId,
          start_date: this.props.filters.startDate || '',
          end_date: this.props.filters.endDate || '',
          ...this.props.filters
        })

        await axios.get(URL, {
          headers: {
            "Authorization" : `JWT ${token.data.refreshToken.token}`
          }
        });

        SweetAlert.fire({
          target: document.getElementById('swal-error'),
          type: 'success',
          title: 'Gerando comprovantes...',
          text: 'Em alguns minutos você receberá um email com o link de download dos comprovantes'
        });
      } catch (e) {
        this.sweetError();
      }
    }

    async handleFileDownload(refresh_token) {
      this.sweetLoading();

      try {
          const token = await refresh_token()

          await axios.post( uri + '/portal/reports/sells/', {
            operator_id: this.props.operatorId,
            start_date: this.props.filters.startDate,
            end_date: this.props.filters.endDate,
            ...this.props.filters
          }, {
            headers: {
              "Authorization" : `JWT ${token.data.refreshToken.token}`
            }
          });

          SweetAlert.fire({
            target: document.getElementById('swal-error'),
            type: 'success',
            title: 'Finalizado',
            text: 'Seu pedido foi processado, confira seu email!'
          });

        } catch (e) {
          this.sweetError();
        }
    }

    async zipOrders(refresh_token) {
      this.sweetLoading();

      try {
        const token = await refresh_token()

        const URL = uri + '/portal/reports/zip-orders/' + buildQueryString({
          partner: this.props.operatorId,
          start_date: this.props.filters.startDate || '',
          end_date: this.props.filters.endDate || '',
          ...this.props.filters
        })

        await axios.get(URL, {
          headers: {
            "Authorization" : `JWT ${token.data.refreshToken.token}`
          }
        });

        SweetAlert.fire({
          target: document.getElementById('swal-error'),
          type: 'success',
          title: 'Gerando arquivo...',
          text: 'Em alguns minutos você receberá um email com o zip dos espelhos do pedidos em anexo.'
        })
      } catch (e) {
        this.sweetError();
      }
    }

    render() {
        const token = sessionStorage.token;
        const variables = {
          token
        }
        return (
            <div className="card shadow mb-6">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col-3 text-left">
                            <h5 className="h3 mb-0">Vendas</h5>
                        </div>
                        <div className="col-9 text-right">
                            <Mutation
                              mutation={PORTAL_REFRESH_TOKEN}
                              variables={variables}
                            >
                            {(refresh_token) => {
                              return(
                                <div>
                                  {/* <button
                                    type="button"
                                    onClick={() => {this.zipReceipts(refresh_token)} }
                                    className="btn btn-sm btn-default"
                                  >Gerar ZIP com comprovantes</button> */}
                                  {/* <button
                                    type="button"
                                    onClick={() => {this.zipOrders(refresh_token)} }
                                    className="btn btn-sm btn-default"
                                  >Receber ZIP dos pedidos</button> */}
                                  <button
                                    type="button"
                                    onClick={() => {this.handleFileDownload(refresh_token)} }
                                    className="btn btn-sm btn-default"
                                  >Baixar CSV</button>
                                </div>
                              )
                            }}
                            </Mutation>
                        </div>
                    </div>
                    <h3 className="mb-0"></h3>
                </div>
                <CardBody {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Card.js